// extracted by mini-css-extract-plugin
module.exports = {"StockEpsPage":"eps_StockEpsPage__TWjZO"};